// extracted by mini-css-extract-plugin
export default {"guideline":"GuidelineCard_guideline__qMgvX","itemHeading":"GuidelineCard_itemHeading__D78YR","itemText":"GuidelineCard_itemText__gmQKM"};